/**
 * LOT 2.6 — affichage HUMAIN des noms (§39).
 * La donnée canonique (souvent « ALEXANDRE GROSS », héritée de l'import)
 * n'est JAMAIS modifiée — seule la présentation est adoucie.
 */
export function humanName(name: string): string {
  if (!name) return name
  // Déjà en casse mixte → on respecte la saisie.
  if (name !== name.toUpperCase()) return name
  return name.toLowerCase().replace(/(^|[\s\-'’])(\p{L})/gu, (_, sep: string, ch: string) => sep + ch.toUpperCase())
}
